import { render, staticRenderFns } from "./OrderDetailPopUp.vue?vue&type=template&id=4816479b&scoped=true"
import script from "./OrderDetailPopUp.vue?vue&type=script&lang=js"
export * from "./OrderDetailPopUp.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailPopUp.vue?vue&type=style&index=0&id=4816479b&prod&lang=scss&scoped=true"
import style1 from "./OrderDetailPopUp.vue?vue&type=style&index=1&id=4816479b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4816479b",
  null
  
)

export default component.exports